export const formatMoney = (number, currency = 'usd') => {
  return number.toLocaleString("en-US", {style:"currency", currency:currency})
}